// Database seeding logic - seeds default format settings on first load
import { isDatabaseEmpty, putFormatSettings } from "@/lib/db";
import type { FormatSettings } from "@/types/database";

// Default format settings
const defaultFormatSettings: FormatSettings = {
  id: "default",
  fontFamily: "serif",
  lineHeight: "normal",
  margin: "normal",
  paragraphStyle: "indented",
};

// Seed the database with default settings if empty
export async function seedIfEmpty(): Promise<void> {
  const isEmpty = await isDatabaseEmpty();

  if (!isEmpty) {
    console.log("[Deckle] Database already has data, skipping seed.");
    return;
  }

  console.log("[Deckle] Empty database detected, seeding defaults...");
  await putFormatSettings(defaultFormatSettings);
  console.log("[Deckle] Default settings seeded.");
}
